(function() {
    var PaymentPlanSelector = function($el) {
        this.$el = $el
        this.$details = this.$el.find('.payment-plan-details')
        this.$radio = this.$el.find('input[name=payment_plan_type]')
        this.$startDateDisplay = this.$el.find('input[name=payment_plan_start_date_display]')
        this.$startDate = this.$el.find('input[name=payment_plan_start_date]')
        this.$endDateDisplay = this.$el.find('input[name=payment_plan_end_date_display]')
        this.$endDate = this.$el.find('input[name=payment_plan_end_date]')
        this.$daySelect = this.$el.find('select[name=payment_plan_day]')

        this.$radio.on('change', this.toggleDetails.bind(this))
        this.$radio.on('change', this.setDayOptions.bind(this))
        this.$el.on('contact.change', this.togglePlanOptions.bind(this))

        this.init()
    
        return this
    }

    PaymentPlanSelector.prototype.init = function () {
        this.$radio.trigger('change')
        this.$daySelect.val(this.$daySelect.data('plan-day'))
    }

    PaymentPlanSelector.prototype.toggleDetails = function (event) {
        if (event.target.disabled) {
            return
        }

        if (this.$radio.filter(':checked').val() != 'Full') {
            this.$details.fadeIn()
        } else {
            this.$details.hide()
            this.$startDateDisplay.val('')
            this.$startDate.val('')
            this.$endDateDisplay.val('')
            this.$endDate.val('')
        }
    }

    PaymentPlanSelector.prototype.togglePlanOptions = function (event) {
        if (!event.isContactable) {
            this.$radio
                .filter('input[value="Full"]')
                .closest('.btn')
                .button('toggle')

            this.$radio
                .not('input[value="Full"]')
                .prop('disabled', true)
                .closest('.btn')
                .addClass('disabled')
        } else {
            this.$radio
                .prop('disabled', false)
                .closest('.btn')
                .removeClass('disabled')
        }
    }

    PaymentPlanSelector.prototype.setDayOptions = function (event) {
        var options = []
        var checked = this.$radio.filter(':checked').val()

        this.$daySelect.html('')

        if (checked == 'Monthly') {
            options = this.getMonthlyDayOptions()
        } else if(checked == 'Weekly') {
            options = this.getWeeklyDayOptions()
        }

        for (var i = 0; i < options.length; i++) {
            if (i == 0) {
                options[i].selected = "selected";
            }
            this.$daySelect.append($('<option/>', options[i]));
        }
    }

    PaymentPlanSelector.prototype.getMonthlyDayOptions = function () {
        var rawOptions = _.range(1, 29)
        var options = []

        for (var i = 0; i < rawOptions.length; i++) {
            options.push({
                value: rawOptions[i],
                text: moment.localeData().ordinal(rawOptions[i]),
            })
        }

        return options
    }

    PaymentPlanSelector.prototype.getWeeklyDayOptions = function () {
        var rawOptions = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
        var options = []

        for (var i = 0; i < rawOptions.length; i++) {
            options.push({
                value: rawOptions[i],
                text: rawOptions[i],
            })
        }

        return options
    }

    $('.payment-plan-selector').each(function () {
        new PaymentPlanSelector($(this))
    })
})()

